import groupBy from 'lodash/groupBy.js'
import {RecommendationSourceType} from '../RecommendationSourceType.js'
import {ConnectionId} from '../../connection/index.js'
import type {Recommendation} from '../Recommendation.js'

export type RecommendationsBySource = {
  sourceType: RecommendationSourceType
  connectionId: ConnectionId
  recommendations: Recommendation[]
}[]

type RecommendationsBySourceType = {
  sourceType: RecommendationSourceType
  recommendations: Recommendation[]
}[]

type RecommendationsByConnectionId = {
  connectionId: ConnectionId
  recommendations: Recommendation[]
}[]

export const groupRecommendationsBySource = (recommendations: Recommendation[]): RecommendationsBySource => {
  return groupRecommendationsBySourceType(recommendations).flatMap(({sourceType, recommendations}) => {
    return groupRecommendationsByConnectionId(recommendations).map(({connectionId, recommendations}) => {
      return {
        sourceType,
        connectionId,
        recommendations,
      }
    })
  })
}

const groupRecommendationsBySourceType = (recommendations: Recommendation[]): RecommendationsBySourceType => {
  return Object.entries(groupBy(recommendations, ({source: {type}}) => type)).map(([sourceType, recommendations]) => ({
    sourceType: RecommendationSourceType.parse(sourceType),
    recommendations,
  }))
}

const groupRecommendationsByConnectionId = (recommendations: Recommendation[]): RecommendationsByConnectionId => {
  return Object.entries(groupBy(recommendations, ({source: {connectionId}}) => connectionId)).map(
    ([connectionId, recommendations]) => ({
      connectionId: ConnectionId.parse(connectionId),
      recommendations,
    }),
  )
}
